import C from "./constants";

export const updateUserDetails = (key, data) => ({
  type: C.UPDATE_USER_DETAILS,
  key,
  data,
});

export const updateUserInfo = (key, data) => ({
  type: C.UPDATE_USER_INFO,
  key,
  data,
});

export const updateSourceInputs = (key, data) => ({
  type: C.UPDATE_SOURCE_INPUT,
  key,
  data,
});

export const updateAdminInputs = (key, data) => ({
  type: C.UPDATE_ADMIN_INPUT,
  key,
  data,
});

export const updateAlert = (data) => ({
  type: C.UPDATE_ALERT,
  data,
});
